<template>
  <!-- 测试用：未绑定设备，查看设备的配置信息和原始数据 -->
  <div id="allDeviceIndex">
    <el-form ref="editDevicePop" class="editDevicePop" :inline="true" :model="editBasicinfo" :rules="editRules" label-position="right" label-width="205px">
      <el-row v-loading="loadEditPop" :gutter="40">
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.SN')" prop="deviceSn">
            <el-input v-model="editBasicinfo.deviceSn" :disabled="true" :placeholder="$t('BondOrUpdateDevice.FindSN')" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('dashboard.DeviceName')" prop="deviceName1">
            <el-input v-model="editBasicinfo.deviceName1" :disabled="true" :placeholder="$t('BondOrUpdateDevice.PleaseEnterAName')" @input="change($event)" />
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Model')" class="redStart">
            <!-- 电池型号 -->
            <el-cascader v-model="batteryCascader" :options="options2" :placeholder="editBasicinfo.batteryBrand + '/' + editBasicinfo.batteryModel" :show-all-levels="true" style="width: 200px" :disabled="noneConfig" @change="batteryModelChange" />
            <p v-show="isShowBatteryModelWarning" class="redWarningFont">{{ $t('BondOrUpdateDevice.SelectBattery') }}</p>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col c520">
          <el-form-item :label="$t('AllDevices.Type')">
            <el-radio v-model="editBasicinfo.c520" :label="5" :disabled="noneConfig" @change="changeEditC520(5)">C5</el-radio>
            <el-radio v-model="editBasicinfo.c520" :label="20" :disabled="noneConfig" @change="changeEditC520(20)">C20</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Capacity')" prop="batteryTotalah">
            <!--容量-->
            <el-input v-model="editBasicinfo.batteryTotalah" :placeholder="$t('BondOrUpdateDevice.EnterBatteryCapacity')" :disabled="noneConfig" @input="change($event)" />
          </el-form-item>
        </el-col>

        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('basicinfo.SystemVoltage')" prop="batterySystemVolt">
            <!--系统电压-->
            <el-input v-model="editBasicinfo.batterySystemVolt" :placeholder="$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage')" :disabled="noneConfig" @input="change($event)" />
          </el-form-item>
        </el-col>
        <!--CAN类型-->
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('CAN')" prop="canFuntion">
            <!-- <template class="ycdd"> -->
            <el-select v-model="editBasicinfo.canFuntion" :placeholder="$t('button.select')" :disabled="noneConfig" @input="change($event)">
              <el-option v-for="item in canOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <!-- </template> -->
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.LevelSensor')">
            <!--液位采集-->
            <el-radio v-model="editBasicinfo.supportWaterlevel" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <el-radio v-model="editBasicinfo.supportWaterlevel" :label="0" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.LEDIndicator')">
            <!--面板指示灯-->
            <el-radio v-model="editBasicinfo.ledSetting" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <el-radio v-model="editBasicinfo.ledSetting" :label="2" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.communication')" class="ycdd">
            <!--485通讯-->
            <el-radio v-model="editBasicinfo.communication485" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.communication485" :label="2" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.currentCollection')" class="ycdd">
            <!--通道2电流采集功能-->
            <el-radio v-model="editBasicinfo.currentCollection2" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.currentCollection2" :label="2" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.AuxVolAcquisition')" class="ycdd">
            <!--Aux电压采集功能-->
            <el-radio v-model="editBasicinfo.voltageCollection2" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.voltageCollection2" :label="2" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.RemoteControl')">
            <!--远程断电-->
            <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="0" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.No') }}</el-radio>
            <el-radio v-model="editBasicinfo.supportRelaycontrol" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Yes') }}</el-radio>
            <!-- <el-input v-model="editBasicinfo.locationSample" type="text" />{{ $t('BondOrUpdateDevice.SecondsTimes') }} -->
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('allDeviceDetail.resetFunction')">
            <el-button class="filter-item" type="primary" :disabled="noneConfig" @click="restoreFactorySet">{{ $t('allDeviceDetail.startReset') }}</el-button>
          </el-form-item>
        </el-col>
        <el-col :lg="12" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item label="APN">
            <!-- <p>{{ editBasicinfo.gprsApnName }}</p> -->
            <el-select v-model="editBasicinfo.gprsApnName" :disabled="noneConfig" @input="change($event)">
              <el-option v-for="item in apnOptions" :key="item" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.SensorType')">
            <!--电流计类型-->
            <el-radio v-model="editBasicinfo.sensorType" :label="2" :disabled="noneConfig" @change="sensorTypeChange">SHUNT</el-radio>
            <el-radio v-model="editBasicinfo.sensorType" :label="1" :disabled="noneConfig" @change="sensorTypeChange">HALL</el-radio>
            <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="1" :disabled="noneConfig" @change="sensorTypeChange">{{ $t('BondOrUpdateDevice.Forward') }}</el-radio>
            <el-radio v-show="isShowHallDetail" v-model="editBasicinfo.hallDirection" :label="2" :disabled="noneConfig" @change="sensorTypeChange">{{ $t('BondOrUpdateDevice.Reverse') }}</el-radio>
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col">
          <el-form-item :label="$t('BondOrUpdateDevice.Track')" class="ycdd">
            <!--运动轨迹-->
            <el-radio v-model="editBasicinfo.motionTrack" :label="1" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.Off') }}</el-radio>
            <el-radio v-model="editBasicinfo.motionTrack" :label="2" :disabled="noneConfig" @change="change($event)">{{ $t('BondOrUpdateDevice.On') }}</el-radio>
            <el-input v-show="editBasicinfo.motionTrack==2" v-model="editBasicinfo.locationSample" type="text" :disabled="noneConfig" @input="change($event)" />
            <span v-show="editBasicinfo.motionTrack==2">{{ $t('BondOrUpdateDevice.SecondsTimes') }}</span>
          </el-form-item>
        </el-col>
        <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col" style="text-align: right;">
          <el-form-item style="text-align: end;">
            <el-button @click="closePop('editDevicePop')">{{ $t('button.Cancel') }}</el-button>
            <el-button :disabled="disabledSubmit||noneConfig" class="filter-item" type="primary" @click="submitEditDeviceModel('editDevicePop')">{{ $t('button.Submit') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="lineWarp">
      <!-- 日期选择器 -->
      <!-- <el-date-picker v-model="selectDay" type="daterange" :range-separator="$t('AllDevices.to')" :start-placeholder="$t('AllDevices.startDate')" :end-placeholder="$t('AllDevices.endDate')" @change="changeSearch" /> -->
      <el-date-picker v-model="popStartDate" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.startDate')" />
      <span>{{ $t('AllDevices.to') }}</span>
      <el-date-picker v-model="popEndDate" type="datetime" size="mini" value-format="timestamp" :placeholder="$t('AllDevices.endDate')" />
      <el-button class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="changeSearch" />
      <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadExcel">Download Raw CSV</el-button>
      <el-button size="mini" type="primary" align="right" style="text-align: center;float:right;margin-right: 40px" @click="downLoadReportExcel">Download Report CSV</el-button>

      <el-form ref="bindDeviceModel" v-loading="lineloading" class="bindDeviceModel" label-position="right">
        <el-form-item style="position:relative;">
          <p v-if="nodata" style="text-align: center;line-height: 30px;top: 50%;position: absolute;width: 100%;transform: translate(0, -50%);z-index:99;">{{ $t("yhubReport.Nodata") }}</p>
          <line-chart :line-chart-data="lineChartData" :height="lineHeight" />
        </el-form-item>
      </el-form>
    </div>

    <!-- 用逗号" , "作小数点分隔符 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowRegionPop" class="regionPop" width="60%" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p class="regionP">{{ $t('yhubReport.UseComma') }} </p>
      <el-radio v-model="regionType" :label="2" @change="change">{{ $t('allDeviceDetail.Yes') }}</el-radio>
      <el-radio v-model="regionType" :label="1" @change="change">{{ $t('allDeviceDetail.no') }}</el-radio>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowRegionPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" @click="submitPop">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <!-- 下载中 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowLoadingPop" width="60%" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
      <p>{{ $t('button.Downloading') }}</p>
    </el-dialog>
  </div>
</template>

<script>
import { getLastOne, deviceBattery, addDeviceAllReset, apnList, addDeviceBindConfig, querySN, cascader, deviceMechcascader } from '@/api/allDevice'
import { listRecordData } from '@/api/yhub'
import lineChart from '@/components/lineChart'
import protobuf from 'protobufjs'
import apiproto from '@/proto/apiproto'
const GNSSProto = apiproto.lookup('com.yhub.pb.APIResponse')

export default {
  name: 'DashboardAdmin',
  components: {
    lineChart
  },
  data() {
    this.apiproto
    this.protobuf
    return {
      // 编辑配置信息------start
      editBasicinfo: {
        c520: 20,
        batteryTotalah: '',
        batteryBrand: '',
        batteryModel: '',
        batterySystemVolt: '',
        canFuntion: '',
        configFrom: '',
        configTime: '',
        configVersion: '',
        extralFuntion: 0,
        motionTrack: '',
        communication485: '',
        currentCollection2: '',
        voltageCollection2: '',
        gprsApnKey: '',
        gprsApnName: '',
        gprsApnUser: '',
        hallDirection: '',
        hallSensorRange: '',
        isSupportPgt: '',
        isSupportRelaycontrol: '',
        isSupportWaterlevel: '',
        ledSetting: '',
        locationSample: '',
        productionData: ''
      },
      options2: [],
      isShowBatteryModelWarning: false,
      canOptions: [
        { value: 0, label: '0 YHUB' },
        { value: 1, label: '1 doogle' },
        { value: 2, label: '2 pgt' },
        { value: 3, label: '3 hsm' },
        { value: 4, label: '4 Kisae' },
        { value: 5, label: '5 BMS' },
        { value: 6, label: '6 GPD' },
        { value: 7, label: '7 hoppecke' },
        { value: 8, label: '8 EVE_BMS' },
        { value: 9, label: '9 SinoboomCAN' },
        { value: 10, label: '10 EVE_F477' },
        { value: 11, label: '11 Yhub_info' }
      ],
      apnOptions: [],
      isShowHallDetail: false,
      disabledSubmit: false,
      findPC: '',
      batteryModelObj: {
        batteryAh: '',
        batteryAhC5: ''
      },
      batteryCascader: [],
      editRules: {
        batteryTotalah: [{ required: true, message: this.$t('BondOrUpdateDevice.EnterBatteryCapacity'), trigger: 'blur' }], // 容量不能为空
        batterySystemVolt: [{ required: true, message: this.$t('BondOrUpdateDevice.PleaseSelectOperatingVoltage'), trigger: 'blur' }] // 系统电压不能为空
      },
      noneConfig: false,
      loadEditPop: true,
      isShowCellNumPop: false,
      // 编辑配置信息------end

      popStartDate: new Date().setHours(0, 0, 0, 0) - 7 * 24 * 60 * 60 * 1000,
      popEndDate: new Date().setHours(0, 0, 0, 0),
      lineloading: true,
      nodata: false,
      lineHeight: '600px',
      lineChartData: {
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d7: [],
        d8: [],
        d9: [],
        d10: [],
        d11: [],
        a1: [],
        a2: [],
        a3: [],
        a4: [],
        a5: [],
        a6: []
      },
      isShowRegionPop: false,
      regionType: 2,
      isShowLoadingPop: false
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
  },
  mounted() {
    this.fetchData()// 电池型号下拉框
    this.apnList()// APN下拉框
    this.bySnGetMcuid() // 通过sn获取mcuid
  },
  methods: {
    apnList() { // APN下拉框
      apnList({}).then(res => {
        if (res.resultCode != 1001 || !res.resultModel) return
        res.resultModel.forEach(v => {
          this.apnOptions.push(v.apnValue)
        })
      })
    },
    bySnGetMcuid() { // 通过sn获取mcuid
      // 绑定设备弹窗--sn改变
      if (this.$route.query.sn.length >= 11 || (this.$route.query.sn.length == 10 && this.$route.query.sn[0] == 'P')) {
        if (this.$route.query.sn) {
          // 去掉首尾空格
          this.editBasicinfo.deviceSn = this.$route.query.sn.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
        }
        querySN({ sn: this.editBasicinfo.deviceSn }).then((res) => {
          if (res.resultCode == 1001) {
            if (!res.resultModel) {
              this.disabledSubmit = true
              this.$notify({
                title: '',
                message: this.$t('AllDevices.enterCorrectsn'),
                type: 'warning',
                duration: 3000
              })
            } else {
              this.$set(this.editBasicinfo, 'mcuId', res.resultModel.yhubMcu)
              this.queryList()// 配置初始化
              this.queryLine() // 折线图初始化
            }
          }
        })
      }
    },
    queryList(row) { // 配置初始化
      this.loadEditPop = true
      getLastOne({ mcuId: this.editBasicinfo.mcuId }).then((res) => {
        this.loadEditPop = false
        if (res.resultCode == 1001) {
          var extralArr2
          if (!res.resultModel || !res.resultModel.jsonData || !JSON.parse(res.resultModel.jsonData).gprs_apn_name) {
            this.$message({
              type: 'error',
              message: this.$t('AllDevices.NoNetworkInfo')// '未找到联网信息，无法绑定，请联系管理员'
            })
            this.noneConfig = true
            this.editBasicinfo.batteryBrand = this.editBasicinfo.batteryModel = ''
            return
          } else {
            this.noneConfig = false
            var jsonData = JSON.parse(res.resultModel.jsonData)
            // console.log(jsonData)
            var newJsonData = {}
            for (var i in jsonData) {
              var oldI = i
              // 由于json中的属性用的是烤串模式命名，需要转化为驼峰法命名
              if (i.indexOf('_') > -1) {
                var arrI = i.split('_')
                arrI.forEach((v, vi) => {
                  if (vi != 0) arrI[vi] = v[0].toUpperCase() + v.slice(1)
                })
                i = arrI.join('')
              }
              newJsonData[i] = jsonData[oldI]
            }
            console.log(newJsonData)
            // this.editBasicinfo = newJsonData
            for (var attr in newJsonData) this.editBasicinfo[attr] = newJsonData[attr]
            this.editBasicinfo.batteryId = newJsonData.sdBattery.battery_id == 0 ? 2 : newJsonData.sdBattery.battery_id
            if (newJsonData.isSupportWaterlevel) {
              this.editBasicinfo.supportWaterlevel = 1
            } else {
              this.editBasicinfo.supportWaterlevel = 0
            }
            if (newJsonData.isSupportRelaycontrol) {
              this.editBasicinfo.supportRelaycontrol = 1
            } else {
              this.editBasicinfo.supportRelaycontrol = 0
            }
            if (!newJsonData.extralFuntion)newJsonData.extralFuntion = 0
            extralArr2 = this.decimalToBinary(newJsonData.extralFuntion, 2)
            // console.log('extral2--', extralArr2)
            this.editBasicinfo.ledSetting = newJsonData.ledSetting == 2 ? 2 : 1
            this.editBasicinfo.hallDirection = newJsonData.hallDirection == 2 ? 2 : 1
            this.editBasicinfo.batteryTotalah = Math.round(newJsonData.batteryTotalAh / 100)
            this.editBasicinfo.batterySystemVolt = newJsonData.batterySystemVolt > 1000 ? Math.round(newJsonData.batterySystemVolt / 100) : newJsonData.batterySystemVolt

            this.editBasicinfo.motionTrack = extralArr2[1] === 1 ? 2 : 1// 运动轨迹
            this.editBasicinfo.communication485 = extralArr2[3] === 1 ? 2 : 1
            this.editBasicinfo.currentCollection2 = extralArr2[4] === 1 ? 2 : 1
            this.editBasicinfo.voltageCollection2 = extralArr2[5] === 1 ? 2 : 1
            this.findPC = this.$t('allDeviceDetail.findPC1') + this.$route.query.sn + this.$t('allDeviceDetail.findPC2')
            if (!this.editBasicinfo.locationSample) this.editBasicinfo.locationSample = 30
            if (this.editBasicinfo.locationSample == 4294967295) this.editBasicinfo.locationSample = 0

            deviceBattery({ id: this.editBasicinfo.batteryId }).then(response => {
              this.batteryModelObj.batteryAh = response.resultModel.batteryAh
              this.batteryModelObj.batteryAhC5 = response.resultModel.batteryAhC5
              this.editBasicinfo.batteryBrand = response.resultModel.batteryBrand
              this.editBasicinfo.batteryModel = response.resultModel.batteryModel
            })
          }
        }
      })
    },
    fetchData() { // 电池型号下拉框
      this.listLoading = true
      cascader().then((response) => {
        // 绑定设备弹窗--电池型号下拉框
        this.options2 = response.resultModel
      })
      deviceMechcascader().then((response) => {
        // 绑定设备弹窗--品牌型号下拉框
        this.optionsPop3 = response.resultModel
      })
    },
    change(e) {
      this.$forceUpdate()
    },
    sensorTypeChange(e) { // 绑定设备弹窗--电流计类型选中
      this.$forceUpdate()
      switch (this.editBasicinfo.sensorType) {
        case '1': this.isShowHallDetail = true; break
        case 1: this.isShowHallDetail = true; break
        default: this.isShowHallDetail = false; break
      }
    },
    batteryModelChange(value) { // 绑定设备弹窗--电池型号选中
      if (!value) value = this.batteryCascader
      console.log('value--', value)
      this.batteryModelObj = value[1]
      this.editBasicinfo.batteryTotalah = this.editBasicinfo.c520 == 5 ? value[1].batteryAhC5 : value[1].batteryAh
      this.editBasicinfo.batteryId = value[1].id
      this.editBasicinfo.batteryBrand = value[1].batteryBrand
      this.editBasicinfo.batteryModel = value[1].batteryModel
      this.isShowBatteryModelWarning = false
    },
    changeEditC520(val) { // 切换C5 C20
      this.$forceUpdate()
      if (this.batteryModelObj.batteryAh) {
        this.editBasicinfo.batteryTotalah = val == 5 ? this.batteryModelObj.batteryAhC5 : this.batteryModelObj.batteryAh
        this.$set(this.editBasicinfo, 'batteryTotalah', this.editBasicinfo.batteryTotalah)
      }
    },
    restoreFactorySet() { // 恢复出厂设置弹窗--打开
      this.restoreFactorySetPop = true
    },
    submitRestoreFactorySet() { // 恢复出厂设置弹窗--提交
      if (!this.restoreFactorySetInfo.passcode) {
        this.isShowResFacSetInfoPasscode = true
        return
      }
      this.$confirm(this.$t('allDeviceDetail.confirmReset'), '', {// '是否恢复出厂设置?'
        confirmButtonText: this.$t('button.Confirm'), // '确定',
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        var param = {
          mcuId: this.editBasicinfo.mcuId,
          pc: this.restoreFactorySetInfo.passcode
        }
        // console.log(param)
        addDeviceAllReset(param).then((res) => {
          if (res.resultCode == 1001) {
            this.restoreFactorySetPop = this.addDevicePop = false
            this.$message({
              type: 'success',
              message: this.$t('allDeviceDetail.resetSucceed') // '重置成功!'
            })
          } else {
            if (res.resultMessage == 'pc error' || res.resultMessage == 'pc null') {
              this.$message({
                type: 'error',
                message: this.$t('BondOrUpdateDevice.IncorrectPasscode') // '重置失败!'
              })
            } else {
              this.$message({
                type: 'error',
                message: this.$t('allDeviceDetail.resetFailed') // '重置失败!'
              })
            }
          }
        })
      }).catch(() => {})
    },
    submitEditDeviceModel(formName) { // 编辑配置设备信息弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = JSON.parse(JSON.stringify(this.editBasicinfo))
          var attrArr = ['batteryId', 'batterySystemVolt', 'batteryTotalah', 'canFuntion', 'configFrom', 'configVersion', 'extralFuntion', 'gprsApnName', 'hallDirection', 'hallSensorRange', 'ledSetting', 'locationSample', 'sensorType', 'supportRelaycontrol', 'supportWaterlevel', 'mcuId']
          for (var attr in params) {
            if (attrArr.indexOf(attr) == -1) {
              delete params[attr] // 去掉无用的参数
            }
          }
          if (!this.editBasicinfo.extralFuntion) this.editBasicinfo.extralFuntion = 0
          var extralArr = this.decimalToBinary(this.editBasicinfo.extralFuntion, 2)
          // motionTrack=2是打开，extralArr[1]=1
          extralArr[1] = this.editBasicinfo.motionTrack == 2 ? 1 : 0
          extralArr[3] = this.editBasicinfo.communication485 == 2 ? 1 : 0
          extralArr[4] = this.editBasicinfo.currentCollection2 == 2 ? 1 : 0
          extralArr[5] = this.editBasicinfo.voltageCollection2 == 2 ? 1 : 0
          params.extral_funtion = params.extralFuntion = Number(this.binaryToDecimal(extralArr))
          params.configFrom = 201
          params.configVersion = this.editBasicinfo.configVersion ? this.editBasicinfo.configVersion + 1 : 1
          // console.log('params---------------', params)
          params.batteryTotalah = params.batteryTotalah * 100
          params.nominalCapacity = this.editBasicinfo.c520 == 20 ? 1 : 2
          if (params.batteryId == 0)params.batteryId = 2
          if (!params.batteryId) {
            this.isShowBatteryModelWarning = true
          } else {
            addDeviceBindConfig(params).then((response) => {
              if (response.resultCode === 1001) {
                this.$notify({
                  title: '',
                  message: this.$t('warningSet.submitted'),
                  type: 'success',
                  duration: 2000
                })
                this.editDevicePop = false
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    decimalToBinary(num, digits) { // 十进制转二进制  digits:代表传过来的是几位数，避免用<10判断出错，如：01 本应该转成8位，却转成了4位
      var myNum = num
      var b = []
      while (1) {
        var remainder = num % 2
        b.unshift(remainder)
        num = parseInt(num / 2)
        if (num == 0) break
      }
      var len
      if (!digits || digits == 1) {
        len = 4 - b.length
        for (var i = 0; i < len; i++) {
          b.unshift(0)
        }
      // } else if (myNum >= 10 && myNum < 100) {
      } else if (digits == 2) {
        len = 8 - b.length
        for (var j = 0; j < len; j++) {
          b.unshift(0)
        }
      }
      return b.reverse()
    },
    binaryToDecimal(arr) { // 二进制转十进制
      var a = []
      var allZero = arr.every(m => { return m == 0 })
      if (allZero) {
        c = 0
      } else {
        arr.forEach((v, i) => {
          var end = arr.slice(i)
          // 如果v=1,并且v后面没有1了，则a等于v及其之前的数。如：arr=[0,1,1,1,1,0,0,0] => a=[0,1,1,1,1]
          if (v == 1 && end.indexOf(1) > -1)a = arr.slice(0, i + 1)
        })
        var b = a.reverse().join('')
        var c = parseInt(b, 2).toString(10)
      }
      return c
    },
    queryLine() { // 折线图初始化
      var params = {
        // sn: this.popSn,
        startDate: new Date(this.popStartDate).getTime() - 1000 * 60 * 60,
        endDate: new Date(this.popEndDate).getTime() + 1000 * 60 * 60,
        mcuId: this.editBasicinfo.mcuId
      }
      this.lineloading = true
      listRecordData(params).then(res => { // 弹窗折线图数据
        this.lineloading = false
        var gnssProto
        const buf = protobuf.util.newBuffer(res)
        gnssProto = GNSSProto.decode(buf)
        const dataList = gnssProto.recordDatas ? gnssProto.recordDatas.recordData : []
        this.nodata = !(dataList.length > 0)
        for (const i in this.lineChartData) {
          this.lineChartData[i] = []
        }
        console.log('dataList----', dataList)
        // ['Cha.(A)', 'Dis.(A)', 'Volt(V)', 'Cha.(Ah)', 'Dis.(Ah)', 'SOC(%)', 'Temp.(℃)']
        var lastTime = null
        var dataSize = dataList.length
        for (const i in dataList) {
          var data = dataList[i]
          var time = dataList[i].time
          if (dataSize > 50000) {
            if (lastTime == null) {
              lastTime = time
            }
            if ((time - lastTime) / 1000 <= 10) {
              continue
            }
            lastTime = time
          }
          var ignition = 1
          var hourMeter = 1
          this.lineChartData.sn = this.$route.query.sn
          this.lineChartData.d3.push([time, (data.ChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d4.push([time, (data.DisChargingCurrent / 100).toFixed(2)])
          this.lineChartData.d5.push([time, (data.voltage / 100).toFixed(2)])
          this.lineChartData.d6.push([time, (data.TotalChargedAh / 100).toFixed(2)])
          this.lineChartData.d7.push([time, (data.TotalDisChargedAh / 100).toFixed(2)])
          this.lineChartData.d8.push([time, (data.soc / 100).toFixed(0)])
          this.lineChartData.d9.push([time, (data.BatteryTemperature / 100).toFixed(0)])
          this.lineChartData.d10.push([time, (data.chargingWh / 100000).toFixed(2)])
          this.lineChartData.d11.push([time, (data.usingWh / 100000).toFixed(2)])
          this.lineChartData.a1.push([time, ignition])
          this.lineChartData.a2.push([time, hourMeter])
          this.lineChartData.a3.push([time, (data.auxBatVol / 100).toFixed(2)])
          if (data.auxCurrent > 0) { // 放电
            this.lineChartData.a4.push([time, (data.auxCurrent / 10).toFixed(2)])
            this.lineChartData.a5.push([time, 0])
          } else if (data.auxCurrent < 0) { // 充电
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, -(data.auxCurrent / 10).toFixed(2)])
          } else {
            this.lineChartData.a4.push([time, 0])
            this.lineChartData.a5.push([time, 0])
          }
          this.lineChartData.a6.push([time, (data.auxSoc / 100).toFixed(2)])
        }
      })
    },
    changeSearch() { // 弹窗--时间选择
      this.lineloading = true
      this.queryLine()
    },
    submitPop() { // Download Raw CSV--下载
      this.isShowRegionPop = false
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.$route.query.sn,
        mcuId: this.editBasicinfo.mcuId,
        startDate: new Date(this.popStartDate).getTime(),
        endDate: new Date(this.popEndDate).getTime()
      }
      var timeZ = new Date().getTimezoneOffset() / 60

      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // console.log(param)
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/exportRecordDataCsv'
      url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + param.sn + '&timeZone=' + paramTimeZ + '&regionType=' + this.regionType
      window.open(url, '_bank')
    },
    downLoadExcel() { // Download Raw CSV--打开选中数字分割选项的弹窗
      this.isShowRegionPop = true
    },
    downLoadReportExcel() { // Download Report CSV
      this.isShowLoadingPop = true
      setTimeout(() => {
        this.isShowLoadingPop = false
      }, 5000)
      var param = {
        sn: this.$route.query.sn,
        mcuId: this.editBasicinfo.mcuId,
        startDate: parseInt(new Date(this.popStartDate).getTime()),
        endDate: parseInt(new Date(this.popEndDate).getTime())
      }
      var timeZ = new Date().getTimezoneOffset() / 60
      var paramTimeZ = 'GMT'
      if (timeZ < 0) {
        paramTimeZ = paramTimeZ + '%2B' + (timeZ * -1)
      } else {
        paramTimeZ = paramTimeZ + (timeZ * -1)
      }
      // var url = 'http://10.0.0.22:8008/v3/report/exportRecordDataCsv'
      var url = process.env.VUE_APP_BASE_API + '/v3/report/getcsv?sn='
      // url += '?endDate=' + param.endDate + '&mcuId=' + param.mcuId + '&startDate=' + param.startDate + '&sn=' + this.listQuery.sn
      url += param.sn + '&startTime=' + param.startDate + '&endTime=' + param.endDate + '&timeZone=' + paramTimeZ
      window.open(url, '_bank')
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
#allDeviceIndex {
  height: 100%;
  .recordRow {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
  }
  .recordRow > div {
    text-align: center;
    width: 25%;
  }
  .recordRow > div p {
    line-height: 1.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .myTable {
    border-collapse: collapse;
    width: 100%;
    border: 1px solid #e6e9ed;
    font-size: 14px;
    color: #606266;
    th {
      color: #909399;
      padding: 0 10px;
    }
    td {
      text-align: center;
      padding: 0 10px;
    }
    .infoP {
      font-size: 1.2em;
      font-weight: bold;
    }
  }
  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fffffff0;
    color: #1990fc;
    z-index: 99;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #headChartWarp {
    height: 320px;
    margin: 0 -20px;
    .el-col {
      height: 100%;
      // background: #fff;
      padding: 0 20px;
    }
    .el-col > div {
      background: #fff;
      height: 100%;
    }
    .el-col:nth-of-type(3) > div {
      padding: 10px;
    }
  }
  #tableWarp {
    // height:500px;
    margin: 32px -20px 0;
    .el-col {
      height: 100%;
      padding: 0 20px;
    }
    .el-col > div {
      background: #fff;
      height: 100%;
    }
    .el-col:nth-of-type(3) > div {
      padding: 10px;
    }
  }
}
.headContent {
  position: absolute;
  // z-index: 999;
  margin: 0 60px -60px 16px;
  float: left;
  top: 20px;
  width: 100%;
}
.headContent img {
  width: 80px;
}
.headContentQuestion {
  font-size: 22px;
  color: #a5a5a5;
  display: inline-block;
  vertical-align: top;
  margin: 7px 0 0 -5px;
  cursor: pointer;
}
.questionPop {
  display: inline-block;
  background: white;
  padding: 14px;
  vertical-align: top;
  box-shadow: 1px 1px 5px #ccc;
  position: absolute;
  z-index: 999;
  margin: -8px 0 0 -240px;
  width: 30%;
}
.allDevice {
  width: 80px;
  height: 54px;
  line-height: 54px;
  vertical-align: top;
  background: white;
  font-size: 36px;
  color: #1990fc;
  text-align: center;
  border: 1px solid #e6e9edc9;
  border-radius: 3px;
  margin-right: -5px;
}

.formRow {
  display: inline-block;
}
.redWarningRadiu {
  font-size: 20px;
  // margin-top: 5px;
  width: 10px;
  height: 10px;
  display: inline-block;
  position: absolute;
  z-index: 200;
  background: red;
  border-radius: 50%;
  left: calc(50% + 15px);
  top: 0px;
}
.chargeDisBox{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dcdfe6;
  padding: 15px;
  .attr{
    margin-bottom: 0px!important;
  }
}
.chargeDisWarp{
  display: inline!important;
  .btnWarp{
    text-align: right;
    margin-top: 20px;
    position: relative;
    z-index: 9999;
  }
}
.lineWarp{
  background: #fff;
  margin-top: 20px;
  padding: 20px;
}
.bindDeviceModel{
  margin-top:20px;
}
.regionP{
  margin: 10px;
  font-weight: bold;
  display: inline-block;
}
.regionPop .el-radio{
  margin-left:10px;
}
</style>
